// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedLayout from './components/ProtectedLayout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 

// Importa las páginas
import Registro from './pages/Registro';
import Login from './pages/Login';
import DashboardNino from './pages/DashboardNino';
import DashboardPadre from './pages/DashboardPadre';
import Perfil from './pages/Perfil';
import ActivarCuenta from './pages/ActivarCuenta';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <>
    <Router>
      <Routes>
        {/* --- Rutas Públicas --- */}
        {/* Estas rutas no tienen el Navbar */}
        <Route path="/login" element={<Login />} />
        <Route path="/registro" element={<Registro />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registro" element={<Registro />} />
        <Route path="/activar/:uid/:token" element={<ActivarCuenta />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
        
        {/* --- Rutas Protegidas --- */}
        {/* Usamos ProtectedLayout como el elemento padre. Todas las rutas
            anidadas dentro se renderizarán en el <Outlet /> del layout */}
        <Route element={<ProtectedLayout />}>
          <Route path="/dashboard-nino" element={<DashboardNino />} />
          <Route path="/dashboard-padre" element={<DashboardPadre />} />
          <Route path="/perfil" element={<Perfil />} />
        </Route>

        {/* Ruta por defecto: redirige a la página de login */}
        <Route path="*" element={<Login />} />
      </Routes>
    </Router>
    <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
    />
  </>

  
  );

}

export default App;